import { getInitParams } from 'utils';

const { profilingConsent = false } = getInitParams();

export default {
  fetched: false,
  assets: [],
  ctas: [],
  customers: [],
  extras: {
    colors: {},
    fb_pixels: [],
    geolocation: {},
    google_analytics_ids: [],
    store: {},
    close_cta: null,
    close_cta_back: false,
    location_required: false,
    profiling_consent: profilingConsent,
    multistore_mode: false,
  },
};
